import React, { useEffect, useState } from 'react'; 
import classes from "../UserDetails/style.module.scss";
import moment from 'moment';
import { CountryCode, getCountryCode } from '../../../../helpers';

const UserInformation = (props) => {
    const { userInfo, slotsBooked } = props
    const [countryCodes, setCountryCodes] = useState({});

    useEffect(() => {
        getCountryCode()?.then((code) => {
            setCountryCodes(code);
        }).catch((err) => {
            console.log(err)
        });
    }, []);

    return (
        <>
            <div className={`${classes.userCardWrapper} mb-4`}>
                <div className={`${classes.detailsWrapper}`}>
                    <div className='flex items-center mb-3'>
                        <div className={`${classes.informationHeader} flex items-center !mb-0 fs-20 `}>
                            {userInfo?.firstName + ' ' + userInfo?.lastName}
                        </div>
                        {userInfo?.approvedByAdmin ?
                            <div className={`${classes.verfiedLogo}`}>Verified</div>
                            : null}
                        {userInfo?.approvedByAdmin == 0 ?
                            <div className={`${classes.declinedLogo}`}>Declined</div>
                            : null}
                    </div>
                    <div className={`${classes.infoWrapper}`}>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>User type</div>
                            <div className={`${classes.infoValue}`}>{userInfo?.role?.name || '-'}</div>
                        </div>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Email</div>
                            <div className={`${classes.infoValue}`}>{userInfo?.email || '-'}</div>
                        </div>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Mobile number</div>
                            <div className={`${classes.infoValue}`}>{userInfo?.mobileNumber || '-'}</div>
                        </div>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Country</div>
                            <div className={`${classes.infoValue}`}>{countryCodes[userInfo?.countryId - 1]?.country_name || '-'}</div>
                        </div>
                        {slotsBooked?.meetingLink ?
                            <div className={`${classes.inforCategory}`}>
                                <div className={`${classes.infoLabel}`}>Meeting info</div>
                                <a href={slotsBooked?.meetingLink} target='blank' className={`${classes.infoValue} ${classes.highlight}`}>
                                    {moment(slotsBooked?.startTime)?.format('DD MMM YYYY, dddd')}
                                </a>
                            </div> : null
                        }
                        {userInfo?.rejectedReason ?
                            <div className={`${classes.inforCategory}`}>
                                <div className={`${classes.infoLabel}`}>Reason for Decline:</div>
                                <div className={`${classes.infoValue}`}>
                                    {userInfo?.rejectedReason}
                                </div>
                            </div> : null
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserInformation